import { FEMachine, InlineMachine } from '@/types/flexe';
import { Badge } from '@/components/ui/badge';
import { Zap, Clock } from 'lucide-react';

interface MachineBadgeProps {
  machine: FEMachine | InlineMachine;
  showDetails?: boolean;
}

export function MachineBadge({ machine, showDetails = false }: MachineBadgeProps) {
  const isInline = 'temp_id' in machine;
  const hasDutyCycle = 'duty_cycle' in machine;
  
  return (
    <div className="flex items-center gap-2">
      <Zap className="h-4 w-4 text-primary" />
      <span className="flex-1">{machine.name}</span>
      {showDetails && (
        <div className="flex items-center gap-1">
          {hasDutyCycle && (
            <Badge variant="outline" className="text-xs">
              {((machine as FEMachine).duty_cycle * 100).toFixed(0)}% duty
            </Badge>
          )}
          {isInline && (
            <Badge variant="secondary" className="text-xs">
              <Clock className="w-3 h-3 mr-1" />
              Tijdelijk
            </Badge>
          )}
        </div>
      )}
    </div>
  );
}
